<template>
  <b-container fluid>

    <!-- no-fade: elimina transición fade que interfiere con dimensiones de gráficas -->
    <b-tabs v-model="activeTab" content-class="mt-3" nav-class="tab-nav-eleva" no-fade>

      <!-- ══════════════════════════════════════════════════════
           TAB 1 · INFORME DE IMPACTO
      ══════════════════════════════════════════════════════ -->
      <b-tab title="Informe de Impacto">

        <b-row>
          <b-col cols="12">
            <h3 class="informe-titulo">INFORME DE IMPACTO {{ yearActual }}</h3>
          </b-col>
        </b-row>

        <!-- Cards estadísticas -->
        <b-row class="stats-cards-row">
          <b-col cols="12" sm="6" lg="3" class="mb-4">
            <div class="stat-card stat-card-primary">
              <div class="stat-icon"><i class="fas fa-chart-line"></i></div>
              <div class="stat-content">
                <h3 class="stat-value">{{ estadisticas.programas_activos }}</h3>
                <p class="stat-label">Programas activos</p>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" lg="3" class="mb-4">
            <div class="stat-card stat-card-success">
              <div class="stat-icon"><i class="fas fa-users"></i></div>
              <div class="stat-content">
                <h3 class="stat-value">{{ estadisticas.usuarios_unicos }}</h3>
                <p class="stat-label">Usuarios únicos</p>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" lg="3" class="mb-4">
            <div class="stat-card stat-card-warning">
              <div class="stat-icon"><i class="fas fa-clock"></i></div>
              <div class="stat-content">
                <h3 class="stat-value">{{ estadisticas.ventana_foco }}</h3>
                <p class="stat-label">Ventana de foco</p>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" lg="3" class="mb-4">
            <div class="stat-card stat-card-info">
              <div class="stat-icon"><i class="fas fa-eye"></i></div>
              <div class="stat-content">
                <h3 class="stat-value">{{ estadisticas.recursos_vistos }}</h3>
                <p class="stat-label">Recursos vistos</p>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- Filtros Tab 1 -->
        <b-row class="my-3 mx-2">
          <b-col cols="6"
                 v-if="$store.getters.usuario && $store.getters.usuario.roles &&
                       ($store.getters.usuario.roles.some(r => r.name === 'admin') ||
                        $store.getters.usuario.roles.some(r => r.name === 'docente'))">
            <label><small>Escuela/Dominio</small></label>
            <v-select
                v-model="filtros.escuela"
                :options="filtros.escuelas_items"
                placeholder="Seleccionar escuela"
                @input="aplicarFiltros()"
            ></v-select>
          </b-col>

          <b-col cols="6"
                 v-if="$store.getters.usuario && $store.getters.usuario.roles &&
                       ($store.getters.usuario.roles.some(r => r.name === 'admin') ||
                        $store.getters.usuario.roles.some(r => r.name === 'docente'))"
                 class="text-right">
            <!-- botón comentado: el tab 2 cumple ahora esta función -->
          </b-col>
        </b-row>

        <!-- Gráficas principales -->
        <b-row>
          <b-col cols="8">
            <b-card class="informe-subtitulo" title="Interacciones por Programa"
                    style="height: 450px; display: flex; flex-direction: column;">
              <div style="flex: 1;">
                <div v-if="loading" class="text-center py-5">
                  <b-spinner variant="primary"></b-spinner>
                  <p class="mt-2">Cargando datos...</p>
                </div>
                <div v-else-if="series.length > 0">
                  <apexchart
                      type="radialBar"
                      height="550"
                      :options="chartOptions"
                      :series="series"
                  />
                </div>
                <div v-else class="text-center py-5">
                  <p class="text-muted">No hay datos de interacciones disponibles</p>
                </div>
              </div>
            </b-card>
          </b-col>

          <b-col cols="4">
            <b-card class="informe-subtitulo" title="Progreso Global" style="height: 450px;">
              <div class="doughnut-wrapper">
                <DoughnutChart
                    :labels="labelsCursos"
                    :data="dataCursos"
                    :backgroundColor="coloresCursos"
                    cutout="70%"
                />
                <div class="mt-3 text-center">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="mb-0 text-success">{{ totalFinalizados }}</h5>
                      <small class="text-muted">Finalizados</small>
                    </div>
                    <div class="col-6">
                      <h5 class="mb-0 text-warning">{{ totalIniciados }}</h5>
                      <small class="text-muted">Iniciados</small>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <!-- Línea de tiempo + Top tiempo
 -->
        <b-row class="mb-5" >
          <b-col cols="6">
            <b-card title="Línea de tiempo (accesos)">
              <div class="chart-wrapper" style="height: 400px;">
                <LineChart
                    :labels="accesosMes.labels"
                    :data="accesosMes.values"
                    label="Accesos"
                    borderColor="#3c83f7"
                    backgroundColor="#d1dffe"
                    :fill="true"
                    :tension="0.5"
                />
              </div>
            </b-card>
          </b-col>
          <b-col cols="6">
            <b-card title="Top 5: Tiempo en plataforma">
              <div class="chart-wrapper" style="height: 400px;">
                <BarChart
                    :labels="topTiempo.labels"
                    :data="topTiempo.values"
                    label="Minutos"
                    :horizontal="true"
                    borderColor="#11b981"
                    backgroundColor="#11b981"
                />
              </div>
            </b-card>
          </b-col>
        </b-row>
                <!-- Tabla actividades de video -->
        <b-row class="mt-5 my-5"  style="height: 450px; display: flex; flex-direction: column;">
          <b-col cols="12" >
            <b-table
                class="table data-table"
                striped="striped"
                hover="hover"
                outlined="outlined"
                :items="usuarios_items"
                :fields="usuarios_headers"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                stacked="md"
                show-empty
                small
            >
              <template #empty="scope">
                <h5 class="text-center">
                  {{ scope.emptyText = 'Por el momento no hay registros que mostrar.' }}
                </h5>
              </template>
              <template #emptyfiltered="scope">
                <h5 class="text-center">
                  {{ scope.emptyFilteredText = 'No hay registros que concuerden con los parámetros de búsqueda.' }}
                </h5>
              </template>
              <template #cell(fecha)="row">
                <span>{{ row.item.fecha | formatDate }}</span>
              </template>
              <template #cell(programa)="row">
                <span class="badge badge-info">{{ row.item.programa }}</span>
              </template>
              <template #cell(actividad)="row">
                <span>{{ row.item.actividad }}</span>
              </template>
              <template #cell(usuario)="row">
                <span>{{ row.item.usuario }}</span>
              </template>
              <template #cell(estado)="row">
                <div class="d-flex align-items-center">
                  <span v-if="row.item.estado === 'play'" class="badge badge-success">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                         fill="currentColor" viewBox="0 0 16 16">
                      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                    </svg>
                    Play
                  </span>
                  <span v-if="row.item.estado === 'pause'" class="badge badge-warning">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                         fill="currentColor" viewBox="0 0 16 16">
                      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
                    </svg>
                    Pause
                  </span>
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="d-flex justify-content-around align-items-center">
                  <b-button variant="success" v-b-modal.modal-prevent-closing size="sm"
                            @click="EditMode(row.item)" class="mr-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                      <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                    </svg>
                  </b-button>
                  <b-button variant="danger" size="sm"
                            @click="ShowmodalBorrarConfirmacion(row.item)" class="ml-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                      <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                    </svg>
                  </b-button>
                </div>
              </template>
            </b-table>

            <div class="d-flex justify-content-between row p-2">
              <div class="col-sm-12 col-md-6 d-flex align-items-center"></div>
              <div class="col-sm-12 col-md-6 d-flex align-items-center justify-content-end">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0">
                </b-pagination>
              </div>
            </div>
          </b-col>
        </b-row>

      </b-tab>
      <!-- /TAB 1 -->


      <!-- ══════════════════════════════════════════════════════
           TAB 2 · INFORME POR USUARIO
      ══════════════════════════════════════════════════════ -->
      <b-tab title="Informe por Usuario" lazy>

        <b-row>
          <b-col cols="12">
            <h3 class="informe-titulo">INFORME DE IMPACTO {{ yearActual }}</h3>
          </b-col>
        </b-row>

        <b-row class="my-3 mx-2">
          <b-col cols="12" md="4">
            <label><small>Seleccionar Estudiante / Docente</small></label>
            <v-select
                v-model="filtros.users"
                :options="filtros.users_items"
                placeholder="Seleccionar usuario"
                @input="aplicarFiltrosUsuario()"
            ></v-select>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-card no-body class="shadow-sm w-100">
              <b-card-header class="d-flex justify-content-between align-items-center bg-white">
                <h4 class="informe-subtitulo">Cursos asignados</h4>
                <b-badge variant="primary" pill>{{ cursosAsignados.length }}</b-badge>
              </b-card-header>

              <b-list-group
                  v-if="cursosAsignados.length"
                  flush
                  class="overflow-auto w-100"
                  style="max-height: 400px;">
                <b-list-group-item
                    v-for="curso in cursosAsignados"
                    :key="curso.id"
                    class="d-flex justify-content-between align-items-center w-100">
                  <div class="flex-grow-1 mr-3 text-truncate">
                    <div class="font-weight-bold text-truncate">{{ curso.nombre }}</div>
                    <small class="text-muted">Inscripción: {{ curso.fecha_inscripcion }}</small>
                  </div>
                  <b-badge
                      :variant="getColorAvance(curso.avance)"
                      pill
                      class="px-3 py-2 flex-shrink-0">
                    {{ curso.avance }}%
                  </b-badge>
                </b-list-group-item>
              </b-list-group>

              <div v-else class="text-center py-5 text-muted">
                <h5 class="mt-3 mb-0">Sin cursos asignados</h5>
              </div>
            </b-card>
          </b-col>

          <b-col cols="6">
            <b-card>
              <h4 class="informe-subtitulo">Actividad por hora</h4>
              <div class="chart-wrapper" style="height: 250px;">
                <BarChart
                    :labels="actividadHora.labels"
                    :data="actividadHora.values"
                    label="Interacciones"
                    backgroundColor="#6b20c1"
                />
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-card no-body class="shadow-sm mt-3">
              <b-card-header class="bg-white d-flex justify-content-between align-items-center">
                <h4 class="informe-subtitulo">Bitácora</h4>
                <b-form-input
                    v-model="bitacoraFilter"
                    size="sm"
                    placeholder="Buscar..."
                    style="max-width: 250px;"
                ></b-form-input>
              </b-card-header>

              <b-card-body>
                <b-table
                    class="table data-table"
                    striped
                    hover
                    borderless
                    :items="bitacora_items"
                    :fields="bitacora_headers"
                    :current-page="bitacoraCurrentPage"
                    :per-page="bitacoraPerPage"
                    :filter="bitacoraFilter"
                    stacked="md"
                    show-empty
                    small>
                  <template #empty="scope">
                    <h5 class="text-center text-muted py-3">
                      {{ scope.emptyText = 'Por el momento no hay registros que mostrar.' }}
                    </h5>
                  </template>
                  <template #emptyfiltered="scope">
                    <h5 class="text-center text-muted py-3">
                      {{ scope.emptyFilteredText = 'No hay registros que concuerden con los parámetros de búsqueda.' }}
                    </h5>
                  </template>
                  <template #cell(fecha)="row">
                    <span class="text-muted">{{ row.item.fecha }}</span>
                  </template>
                  <template #cell(hora)="row">
                    <span class="text-muted">{{ row.item.hora }}</span>
                  </template>
                  <template #cell(tipo)="row">
                    <b-badge :variant="getColorTipo(row.item.tipo)" pill>
                      {{ row.item.tipo }}
                    </b-badge>
                  </template>
                  <template #cell(detalle)="row">
                    <span>{{ row.item.detalle }}</span>
                  </template>
                </b-table>

                <div class="d-flex justify-content-between align-items-center mt-2"
                     v-if="bitacora_items.length">
                  <small class="text-muted">Total: {{ bitacora_items.length }} registros</small>
                  <b-pagination
                      v-model="bitacoraCurrentPage"
                      :total-rows="bitacora_items.length"
                      :per-page="bitacoraPerPage"
                      size="sm"
                      class="mb-0">
                  </b-pagination>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

      </b-tab>
      <!-- /TAB 2 -->


      <!-- ══════════════════════════════════════════════════════
           TAB 3 · REPORTES ELEVA
      ══════════════════════════════════════════════════════ -->
      <b-tab title="Reportes" lazy>

        <b-row>
          <b-col cols="12">
            <div class="card-block">
              <div class="card-body p-2">

                <div class="d-flex align-items-center justify-content-center flex-column p-2">
                  <p class="mt-5 mb-2" style="color: #6c757d;">
                    Consulta la actividad de tu equipo docente
                  </p>
                  <h1 class="mb-5" style="color: #8b5cf6;">Reportes de la plataforma</h1>
                </div>

                <b-row class="align-items-center my-4 mx-2">
                  <b-col cols="12" md="8" class="mb-3 mb-md-0">
                    <p class="mb-0" style="color: #333;">
                      Haz clic sobre cada tarjeta para visualizar la información.
                      Puedes descargar un informe completo haciendo clic en descargar concentrado.
                    </p>
                  </b-col>
                  <b-col cols="12" md="4" class="text-md-right">
                    <b-button class="btn-studioAPP" variant="outline-primary"
                              size="lg" @click="mostrarModalDescarga">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                           fill="currentColor" class="mr-2" viewBox="0 0 16 16"
                           style="vertical-align: middle;">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                      </svg>
                      Descargar concentrado
                    </b-button>
                  </b-col>
                </b-row>

                <div class="row row-cols-1 row-cols-md-3 g-4 mt-3 justify-content-center">

                  <div class="col-12 col-md-6 col-lg-4 mb-4">
                    <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column"
                         @click="navigateTo('ElevaReporteAcceso')">
                      <div class="card-body d-flex flex-column align-items-center text-center p-4"
                           style="border-left: 6px solid #8b5cf6; border-top-left-radius: 15px; border-bottom-left-radius: 15px;">
                        <div class="icon-circle bg-primary mb-3">
                          <img src="@/assets/images/reports-icons/exit_to_app.svg" alt="Acceso">
                        </div>
                        <h5 class="mb-2 fw-bold">Acceso</h5>
                        <p class="text-muted mb-0" style="font-size: 15px;">
                          Visualiza la última conexión de los usuarios activos por escuela.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 col-lg-4 mb-4">
                    <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column"
                         @click="navigateTo('ElevaReporteAccesoTiempo')">
                      <div class="card-body d-flex flex-column align-items-center text-center p-4"
                           style="border-left: 6px solid #ff6600; border-top-left-radius: 15px; border-bottom-left-radius: 15px;">
                        <div class="icon-circle bg-warning mb-3">
                          <img src="@/assets/images/reports-icons/timer.svg" alt="Acceso-tiempo">
                        </div>
                        <h5 class="mb-2 fw-bold">Acceso / tiempo</h5>
                        <p class="text-muted mb-0" style="font-size: 15px;">
                          Visualiza los ingresos a la plataforma por usuario, incluyendo fecha, horarios y tiempo estimado de uso.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 col-lg-4 mb-4">
                    <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column"
                         @click="navigateTo('AccesosPorUsuarioDia')">
                      <div class="card-body d-flex flex-column align-items-center text-center p-4"
                           style="border-left: 6px solid #8b5cf6; border-top-left-radius: 15px; border-bottom-left-radius: 15px;">
                        <div class="icon-circle bg-primary mb-3">
                          <img src="@/assets/images/reports-icons/calendar_clock.svg" alt="Acceso por usuario por día">
                        </div>
                        <h5 class="mb-2 fw-bold">Acceso por usuario, por día</h5>
                        <p class="text-muted mb-0" style="font-size: 15px;">
                          Visualiza la primera y última hora de ingreso de cada usuario por día, así como el número total de ingresos.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 col-lg-4 mb-4">
                    <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column"
                         @click="navigateTo('ElevaReporteHorariosIngreso')">
                      <div class="card-body d-flex flex-column align-items-center text-center p-4"
                           style="border-left: 6px solid #ff6600; border-top-left-radius: 15px; border-bottom-left-radius: 15px;">
                        <div class="icon-circle bg-warning mb-3">
                          <img src="@/assets/images/reports-icons/nest_clock.svg" alt="Horarios de ingreso">
                        </div>
                        <h5 class="mb-2 fw-bold">Horarios de ingreso</h5>
                        <p class="text-muted mb-0" style="font-size: 15px;">
                          Visualiza el número total de ingresos por usuario en cada día, incluyendo el nombre completo del usuario.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 col-lg-4 mb-4">
                    <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column"
                         @click="navigateTo('ActividadesVideo')">
                      <div class="card-body d-flex flex-column align-items-center text-center p-4"
                           style="border-left: 6px solid #8b5cf6; border-top-left-radius: 15px; border-bottom-left-radius: 15px;">
                        <div class="icon-circle bg-primary mb-3">
                          <img src="@/assets/images/reports-icons/play_pause.svg" alt="Actividades por video">
                        </div>
                        <h5 class="mb-2 fw-bold">Actividades por video</h5>
                        <p class="text-muted mb-0" style="font-size: 15px;">
                          Visualiza todas las acciones de video realizadas por los usuarios (play, pause, ended, etc.) con el tiempo exacto.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 col-lg-4 mb-4">
                    <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column"
                         @click="navigateTo('AvanceUsuariosCurso')">
                      <div class="card-body d-flex flex-column align-items-center text-center p-4"
                           style="border-left: 6px solid #ff6600; border-top-left-radius: 15px; border-bottom-left-radius: 15px;">
                        <div class="icon-circle bg-warning mb-3">
                          <img src="@/assets/images/reports-icons/book_ribbon.svg" alt="Avance de usuario por curso">
                        </div>
                        <h5 class="mb-2 fw-bold">Avance de usuario por curso</h5>
                        <p class="text-muted mb-0" style="font-size: 15px;">
                          Visualiza el porcentaje de avance de cada usuario en sus cursos, con información sobre el estado actual y tiempo transcurrido.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 col-lg-4 mb-4">
                    <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column"
                         @click="navigateTo('CursosTerminados')">
                      <div class="card-body d-flex flex-column align-items-center text-center p-4"
                           style="border-left: 6px solid #8b5cf6; border-top-left-radius: 15px; border-bottom-left-radius: 15px;">
                        <div class="icon-circle bg-primary mb-3">
                          <img src="@/assets/images/reports-icons/flag.svg" alt="Curso finalizado por usuario">
                        </div>
                        <h5 class="mb-2 fw-bold">Curso finalizado por usuario</h5>
                        <p class="text-muted mb-0" style="font-size: 15px;">
                          Visualiza el porcentaje de avance de cada usuario en sus cursos, con información sobre el estado actual y tiempo transcurrido.
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </b-col>
        </b-row>

      </b-tab>
      <!-- /TAB 3 -->

    </b-tabs>


    <!-- MODAL DESCARGA CONSOLIDADO (Tab 3) -->
    <b-modal
        id="modal-descarga-consolidado"
        ref="modalDescarga"
        title="Descargar reporte consolidado"
        size="lg"
        @ok="descargarConcentrado"
        ok-title="Descargar"
        cancel-title="Cancelar"
        ok-variant="primary">
      <p class="mb-3 text-muted">
        Selecciona los filtros para generar el reporte consolidado con todos los datos en un solo archivo Excel con múltiples pestañas.
      </p>
      <b-row>
        <b-col cols="12"
               v-if="$store.getters.usuario && $store.getters.usuario.roles &&
                     ($store.getters.usuario.roles.some(r => r.name === 'admin') ||
                      $store.getters.usuario.roles.some(r => r.name === 'docente'))">
          <label><small>Escuela/Dominio</small></label>
          <v-select
              v-model="filtros.escuela"
              :options="filtros.escuelas_items"
              placeholder="Seleccionar escuela">
          </v-select>
        </b-col>
        <b-col cols="12" md="6" class="mt-3">
          <label><small>Fecha inicio</small></label>
          <b-form-datepicker
              v-model="filtros.fecha_inicio"
              locale="es" placeholder="Fecha inicio" size="sm"
              label-help="" label-today-button="Hoy" today-button
              label-no-date-selected="No se ha elegido fecha">
          </b-form-datepicker>
        </b-col>
        <b-col cols="12" md="6" class="mt-3">
          <label><small>Fecha fin</small></label>
          <b-form-datepicker
              v-model="filtros.fecha_fin"
              locale="es" placeholder="Fecha fin" size="sm"
              label-help="" label-today-button="Hoy" today-button
              label-no-date-selected="No se ha elegido fecha">
          </b-form-datepicker>
        </b-col>
      </b-row>
      <b-alert class="mt-3 mb-0" show variant="info">
        <small>
          <strong>Nota:</strong> El reporte incluirá todas las pestañas: Acceso, Acceso/tiempo,
          Accesos por usuario/día, Horarios de ingreso, Actividades por video, Avance de usuarios
          por curso y Cursos terminados.
        </small>
      </b-alert>
    </b-modal>

  </b-container>
</template>


<script>
import LineChart     from '@/components/Graficas/LineChart.vue'
import BarChart      from '@/components/Graficas/BarChart.vue'
import DoughnutChart from '@/components/Graficas/DoughnutChart.vue'
import Bugsnag       from '@bugsnag/js'

export default {
  name: 'DashboardGraficas',
  components: {
    LineChart,
    BarChart,
    DoughnutChart,
  },

  mounted() {
    // Tab 1: cargar datos y, al terminar, disparar resize para que Chart.js / ApexCharts
    // recalculen dimensiones ya con el contenedor estable.
    this.getEscuelas()
    this.getInteraccionesPorPrograma()
    this.getCursosFinalizadosVsIniciados()
    this.getAccesosPorMes()
    this.getTopTiempoEnPlataforma()
    this.getActividadesVideo()
    this.getEstadisticasGenerales()

    // Tab 2 (datos precargados; los componentes se montan al abrir el tab por lazy)
    this.getUsuariosDominio()
    this.getCursosAsignados()
    this.getActividadPorHora()
    this.getBitacoraPersonal()

    // FIX para escalado de gráficas dentro de b-tabs:
    // emitir un evento resize global después de un breve delay para forzar
    // a Chart.js y ApexCharts a recalcular dimensiones del canvas.
    this.$nextTick(() => {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 300)
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 800)
    })
  },

  methods: {

    // ── Navegación ──────────────────────────────────────────────────────────

    irInformeUsuario() {
      this.activeTab = 1
    },

    navigateTo(routeName) {
      this.$router.push({ name: routeName })
    },

    mostrarModalDescarga() {
      this.$refs.modalDescarga.show()
    },

    // ── Filtros ─────────────────────────────────────────────────────────────

    aplicarFiltros() {
      this.getInteraccionesPorPrograma()
      this.getCursosFinalizadosVsIniciados()
      this.getAccesosPorMes()
      this.getTopTiempoEnPlataforma()
      this.getActividadesVideo()
      this.getEstadisticasGenerales()
      // Forzar resize tras aplicar filtros también
      this.$nextTick(() => {
        setTimeout(() => window.dispatchEvent(new Event('resize')), 300)
      })
    },

    aplicarFiltrosUsuario() {
      this.getCursosAsignados()
      this.getActividadPorHora()
      this.getBitacoraPersonal()
      this.$nextTick(() => {
        setTimeout(() => window.dispatchEvent(new Event('resize')), 300)
      })
    },

    // ── Compartidos ─────────────────────────────────────────────────────────

    async getEscuelas() {
      try {
        let response = await this.$api.get(`/api/reportes/escuelas`)
        let { success, escuelas } = response.data
        if (success) {
          this.filtros.escuelas_items = escuelas
        }
      } catch (error) {
        Bugsnag.notify(new Error('Método: getEscuelas() ' + error.message))
      }
    },

    async getUsuariosDominio() {
      try {
        let response = await this.$api.get(`/api/graficas/get-usuarios-dominio`)
        let { success, usuarios } = response.data
        if (success) {
          this.filtros.users_items = usuarios
        }
      } catch (error) {
        Bugsnag.notify(new Error('Método: getUsuariosDominio() ' + error.message))
      }
    },

    // ── Tab 1 ────────────────────────────────────────────────────────────────

    async getTopTiempoEnPlataforma() {
      try {
        let params = { escuela_id: this.filtros.escuela.id || 0 }
        const response = await this.$api.get('/api/graficas/top-tiempo-plataforma', { params })
        const { success, message, data, color } = response.data
        if (success) {
          this.topTiempo.labels = data.labels
          this.topTiempo.values = data.values
        }
        this.toast('b-toaster-bottom-center', true, message, color)
      } catch (error) {
        console.error('❌ Error al obtener top tiempo:', error)
        this.toast('b-toaster-bottom-center', true, 'Error al cargar top tiempo', 'danger')
      }
    },

    async getAccesosPorMes() {
      try {
        let params = { escuela_id: this.filtros.escuela.id || 0 }
        const response = await this.$api.get('/api/graficas/accesos-por-mes', { params })
        const { success, message, data, color } = response.data
        if (success) {
          this.accesosMes.labels = data.labels
          this.accesosMes.values = data.values
        }
        this.toast('b-toaster-bottom-center', true, message, color)
      } catch (error) {
        console.error('❌ Error al obtener accesos por mes:', error)
        this.toast('b-toaster-bottom-center', true, 'Error al cargar accesos', 'danger')
      }
    },

    async getInteraccionesPorPrograma() {
      this.loading = true
      try {
        let params = { escuela_id: this.filtros.escuela.id || 0 }
        const response = await this.$api.get('/api/graficas/interacciones-por-programa', { params })
        let { success, message, data, color } = response.data

        if (success && data.length > 0) {
          this.series = data.map(item => Number(item.value))
          this.chartOptions = {
            chart: { type: 'radialBar' },
            plotOptions: {
              radialBar: {
                startAngle: -90,
                endAngle: 90,
                hollow: { size: '30%' },
                track: { background: '#e7e7e7', strokeWidth: '97%', margin: 5 },
                dataLabels: {
                  name: {
                    show: true, fontSize: '14px', fontWeight: 500,
                    color: '#666', offsetY: -10
                  },
                  value: {
                    show: true, fontSize: '18px', fontWeight: 600,
                    color: '#333', offsetY: -5,
                    formatter: function (val) {
                      const numVal = Number(val)
                      return isNaN(numVal) ? '0%' : numVal.toFixed(1) + '%'
                    }
                  }
                }
              }
            },
            colors: data.map(item => item.color),
            labels: data.map(item => item.label),
            legend: {
              show: true, position: 'bottom', horizontalAlign: 'center',
              fontSize: '14px', fontWeight: 500,
              markers: { width: 12, height: 12, radius: 2 },
              itemMargin: { horizontal: 10, vertical: 5 }
            },
            tooltip: {
              enabled: true,
              y: {
                formatter: function (val) {
                  const numVal = Number(val)
                  return isNaN(numVal) ? '0%' : numVal.toFixed(1) + '%'
                },
                title: {
                  formatter: function (seriesName) { return seriesName + ':' }
                }
              }
            },
            responsive: [{ breakpoint: 480, options: { legend: { fontSize: '12px' } } }]
          }
        } else {
          this.series = []
          this.chartOptions.labels = []
          this.chartOptions.colors = []
        }
        this.toast('b-toaster-bottom-center', true, message, color)
      } catch (error) {
        console.error('❌ Error al obtener interacciones:', error)
        this.toast('b-toaster-bottom-center', true, 'Error al cargar los datos', 'danger')
        this.series = []
      } finally {
        this.loading = false
      }
    },

    async getCursosFinalizadosVsIniciados() {
      this.loadingCursos = true
      try {
        let params = { escuela_id: this.filtros.escuela.id || 0 }
        const response = await this.$api.get('/api/graficas/cursos-finalizados-vs-iniciados', { params })
        const { success, message, data, color, finalizados, iniciados } = response.data
        if (success && data.valores.length > 0) {
          this.labelsCursos     = data.labels
          this.dataCursos       = data.valores
          this.coloresCursos    = data.colores
          this.totalFinalizados = finalizados
          this.totalIniciados   = iniciados
        }
        this.toast('b-toaster-bottom-center', true, message, color)
      } catch (error) {
        console.error('Error:', error)
        this.toast('b-toaster-bottom-center', true, 'Error al cargar datos', 'danger')
      } finally {
        this.loadingCursos = false
      }
    },

    async getActividadesVideo() {
      try {
        let params = { escuela_id: this.filtros.escuela.id || 0 }
        const response = await this.$api.get('/api/graficas/actividades-video', { params })
        const { success, message, data, total, color } = response.data
        if (success) {
          this.usuarios_items = data
          this.totalRows      = total
        }
        this.toast('b-toaster-bottom-center', true, message, color)
      } catch (error) {
        console.error('❌ Error al obtener actividades de video:', error)
        this.toast('b-toaster-bottom-center', true, 'Error al cargar actividades', 'danger')
      }
    },

    async getEstadisticasGenerales() {
      try {
        let params = { escuela_id: this.filtros.escuela.id || 0 }
        const response = await this.$api.get('/api/graficas/estadisticas-generales', { params })
        const { success, message, data, color } = response.data
        if (success) {
          this.estadisticas = data
        }
        this.toast('b-toaster-bottom-center', true, message, color)
      } catch (error) {
        console.error('❌ Error al obtener estadísticas:', error)
        this.toast('b-toaster-bottom-center', true, 'Error al cargar estadísticas', 'danger')
      }
    },

    // ── Tab 2 ────────────────────────────────────────────────────────────────

    async getCursosAsignados() {
      try {
        let params = { user_id: this.filtros.users.id || 0 }
        const response = await this.$api.get('/api/graficas/get-cursos-asignados', { params })
        const { success, data } = response.data
        if (success) {
          this.cursosAsignados = data
        }
      } catch (error) {
        console.error('❌ Error al obtener cursos asignados:', error)
      }
    },

    async getActividadPorHora() {
      try {
        let params = { user_id: this.filtros.users.id || 0 }
        const response = await this.$api.get('/api/graficas/get-actividad-por-hora', { params })
        const { success, data } = response.data
        if (success) {
          this.actividadHora.labels = data.labels
          this.actividadHora.values = data.values
        }
      } catch (error) {
        console.error('❌ Error al obtener actividad por hora:', error)
      }
    },

    async getBitacoraPersonal() {
      try {
        let params = { user_id: this.filtros.users.id || 0 }
        const response = await this.$api.get('/api/graficas/get-bitacora-personal', { params })
        const { success, data } = response.data
        if (success) {
          this.bitacora_items = data
        }
      } catch (error) {
        console.error('❌ Error al obtener bitácora:', error)
      }
    },

    getColorAvance(avance) {
      if (avance >= 80) return 'success'
      if (avance >= 50) return 'primary'
      if (avance >= 25) return 'warning'
      return 'secondary'
    },

    getColorTipo(tipo) {
      const map = {
        'Acceso':     'success',
        'Video':      'primary',
        'Navegación': 'info',
        'Actividad':  'warning',
        'Evaluación': 'danger',
        'Entrega':    'dark',
        'Material':   'secondary',
        'Duda':       'info',
        'Curso':      'success',
        'Edición':    'warning',
        'Otro':       'light',
      }
      return map[tipo] || 'secondary'
    },

    // ── Tab 3 ────────────────────────────────────────────────────────────────

    async descargarConcentrado() {
      try {
        let params = {
          escuela_id:   this.filtros.escuela.id || 0,
          fecha_inicio: this.filtros.fecha_inicio || '',
          fecha_fin:    this.filtros.fecha_fin    || '',
        }
        const response = await this.$api.get('/api/reportes/consolidado/exportar', {
          params,
          responseType: 'blob',
          headers: {
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv, application/zip'
          }
        })

        if (!response.data || response.data.size === 0) {
          throw new Error('No se recibieron datos del servidor')
        }

        const blob        = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/octet-stream'
        })
        const downloadUrl = window.URL.createObjectURL(blob)
        const link        = document.createElement('a')
        link.href         = downloadUrl

        let filename    = 'reporte_consolidado.xlsx'
        let disposition = response.headers &&
            (response.headers['content-disposition'] || response.headers['Content-Disposition'])
        if (disposition && disposition.indexOf('filename=') !== -1) {
          filename = disposition.split('filename=')[1].replace(/['";]/g, '').trim()
        }

        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)

        this.$bvToast.toast('El reporte se ha descargado correctamente.', {
          title: 'Descarga exitosa', variant: 'success', solid: true,
          autoHideDelay: 3000, toaster: 'b-toaster-bottom-center'
        })
      } catch (error) {
        console.error('Error al descargar reporte:', error)
        this.$bvToast.toast(error.message || 'No se pudo descargar el reporte', {
          title: 'Error en la descarga', variant: 'danger', solid: true,
          autoHideDelay: 5000, toaster: 'b-toaster-bottom-center'
        })
      }
    },

  }, // /methods

  data() {
    return {
      yearActual: new Date().getFullYear(),
      activeTab: 0,

      filtros: {
        escuela:        { id: 0, label: 'Todas las escuelas' },
        escuelas_items: [],
        users:          { id: 0, label: 'Selecciona un usuario' },
        users_items:    [],
        fecha_inicio:   null,
        fecha_fin:      null,
      },

      estadisticas: {
        programas_activos: 0,
        usuarios_unicos:   0,
        ventana_foco:      '—',
        recursos_vistos:   0,
      },

      topTiempo:  { labels: [], values: [] },
      accesosMes: { labels: [], values: [] },

      loadingCursos:    false,
      labelsCursos:     [],
      dataCursos:       [],
      coloresCursos:    [],
      totalFinalizados: 0,
      totalIniciados:   0,

      loading: false,
      series:  [],
      chartOptions: {
        chart: { type: 'radialBar' },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle:    90,
            hollow:  { size: '30%' },
            track:   { background: '#e7e7e7', strokeWidth: '97%', margin: 5 },
            dataLabels: {
              name:  { fontSize: '14px', offsetY: -10 },
              value: {
                fontSize: '18px', fontWeight: 600, offsetY: -5,
                formatter: function (val) { return val.toFixed(1) + '%' }
              }
            }
          }
        },
        colors: [],
        labels: [],
        legend: {
          show: true, position: 'bottom', horizontalAlign: 'center',
          fontSize: '14px',
          markers:    { width: 12, height: 12, radius: 2 },
          itemMargin: { horizontal: 10, vertical: 5 }
        }
      },

      usuarios_items: [],
      usuarios_headers: [
        { key: 'fecha',     label: 'FECHA',    sortable: true  },
        { key: 'programa',  label: 'PROGRAMA', sortable: true  },
        { key: 'curso',     label: 'CURSO',    sortable: true  },
        { key: 'actividad', label: 'ACTIVIDAD',sortable: true  },
        { key: 'usuario',   label: 'USUARIO',  sortable: true  },
        { key: 'estado',    label: 'ESTADO',   sortable: true  },
      ],
      currentPage: 1,
      perPage:     10,
      totalRows:   0,
      filter:      null,
      filterOn:    [],
      search:      '',

      cursosAsignados: [],
      actividadHora:   { labels: [], values: [] },

      bitacora_items: [],
      bitacora_headers: [
        { key: 'fecha',   label: 'FECHA',   sortable: true  },
        { key: 'hora',    label: 'HORA',    sortable: true  },
        { key: 'tipo',    label: 'TIPO',    sortable: true  },
        { key: 'detalle', label: 'DETALLE', sortable: false },
      ],
      bitacoraCurrentPage: 1,
      bitacoraPerPage:     10,
      bitacoraFilter:      null,
    }
  },
}
</script>


<style scoped>

.tab-nav-eleva {
  display: flex;
  width: 100%;
  border-bottom: 2px solid #e0e0e0;
}

.tab-nav-eleva .nav-item {
  flex: 1;
  text-align: center;
}

.tab-nav-eleva .nav-link {
  width: 100%;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #888;
  border: none;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  padding: 14px 0;
  transition: color .2s ease, border-color .2s ease;
}

.tab-nav-eleva .nav-link:hover {
  color: #6b20c1;
  background: transparent;
  border-bottom-color: #d4b8f0;
}

.tab-nav-eleva .nav-link.active {
  color: #6b20c1;
  background: transparent;
  border-bottom: 3px solid #6b20c1;
  font-weight: 600;
}


.chart-wrapper {
  position: relative;
  width: 100%;
}

/* ── Títulos ─────────────────────────────────────────────── */
.informe-titulo {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 31px;
  color: #434343;
  margin: 1rem 0;
}

.informe-subtitulo {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #434343;
  margin: 1rem 0;
}

/* ── Stat cards ─────────────────────────────────────────── */
.stats-cards-row { margin-bottom: 30px; }

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  height: 100%;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.stat-icon i { color: white; }

.stat-content { flex: 1; }

.stat-value {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  color: #333;
  line-height: 1.2;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin: 4px 0 0;
  font-weight: 500;
}

.stat-card-primary  { border-left-color: #6b20c1; }
.stat-card-primary .stat-icon { background: linear-gradient(135deg, #6b20c1 0%, #8e44d1 100%); }
.stat-card-primary:hover  { border-left-color: #8e44d1; }

.stat-card-success  { border-left-color: #28a745; }
.stat-card-success .stat-icon { background: linear-gradient(135deg, #28a745 0%, #3db85f 100%); }
.stat-card-success:hover  { border-left-color: #3db85f; }

.stat-card-warning  { border-left-color: #ff5e20; }
.stat-card-warning .stat-icon { background: linear-gradient(135deg, #ff5e20 0%, #ff7840 100%); }
.stat-card-warning:hover  { border-left-color: #ff7840; }

.stat-card-info     { border-left-color: #17a2b8; }
.stat-card-info .stat-icon { background: linear-gradient(135deg, #17a2b8 0%, #20c4db 100%); }
.stat-card-info:hover     { border-left-color: #20c4db; }

@media (max-width: 992px) {
  .stat-value { font-size: 24px; }
  .stat-label { font-size: 13px; }
  .stat-icon  { width: 48px; height: 48px; font-size: 20px; }
}

@media (max-width: 576px) {
  .stat-card  { padding: 20px; gap: 16px; }
  .stat-value { font-size: 22px; }
  .stat-label { font-size: 12px; }
}

/* ── Report cards (Tab 3) ───────────────────────────────── */
.card { border-radius: 15px; }

.card-hover {
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.fw-bold { font-weight: 600; }

.icon-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-primary { background-color: #8b5cf6 !important; }
.bg-warning  { background-color: #ff6600 !important; }

</style>
